// AI Generated Component
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    standalone: false,
    selector: 'form-global-policy-boxes',
    template: `
<div class="global-policy-form-boxes pt-6">
    <div class="btn-group full-width col-48 px-2">
        <span (keyup)="$event.key === 'Enter' && switchTab('settings')"
              class="btn btn-border-radius add-rule-btn col-24 inner-r-none inner-b-small inner-t-small"
              [class.active]="tab === 'settings'"
              (click)="switchTab('settings')"
              tabindex="0">
            <span class="fas fa-cog fa-lg"></span>
            <span translate>Settings</span>
        </span>
        <span (keyup)="$event.key === 'Enter' && switchTab('rule')"
              class="btn btn-border-radius add-rule-btn col-24 inner-l-none inner-b-small inner-t-small"
              [class.active]="tab === 'rule'"
              (click)="switchTab('rule')"
              tabindex="0">
            <span class="fas fa-hand-pointer fa-lg"></span>
            <span translate>Add rule to the policy</span>
        </span>
    </div>

    <form-global-policy-settings *ngIf="tab === 'settings'" [policy]="policy"></form-global-policy-settings>
    <form-global-policy-element *ngIf="tab === 'rule'" [elements]="elements" [policy]="policy"></form-global-policy-element>
</div>
    `,
})
export class FormGlobalPolicyBoxesComponent implements OnInit {
    @Input() policy: any;
    @Input() elements: any;
    @Input() tab: any;

    @Output() tabChange: EventEmitter<string> = new EventEmitter<string>();

    constructor () {}

    ngOnInit (): void {
        this.activate();
    }

    switchTab (tabName: string): void {
        this.tab = tabName;
        this.tabChange.emit(this.tab);
    }

    private activate (): void {
        this.switchTab('settings');
    }
}
